import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Title, Table } from 'rbx';
import { sortBy, reverse } from 'lodash';
import Footer from './Footer';

import BookingByAttendeeList from './BookByAttendeeList';
import {
  Table as CustomTable,
  Box,
  Pagination,
} from '../../../components/elements';

const Wrapper = styled.div`
  padding: 0.5rem 1rem;
`;

const Heading = styled.div`
  padding: 0.5rem 1rem;
  background-color: #f6f6f6;
  margin-bottom: 1rem;
`;

const BookingByAttendee = ({ tickets, booking, setSort }) => {
  console.log('BookingByAttendee -> tickets', tickets);
  const [ticketData, setTicketData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [pageFrom, setPageFrom] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalElements, setTotalElements] = useState();
  const [listSize] = useState(10);

  const [attendeeNameSort, setAttendeeNameSort] = useState('AES');
  const [emailSort, setEmailSort] = useState('AES');
  const [mobileSort, setMobileSort] = useState('AES');
  const [ageSort, setAgeSort] = useState('AES');
  const [ticketNameSort, setTicketNameSort] = useState('AES');
  const [ticketNumberSort, setTicketNumberSort] = useState('AES');

  const [step, setStep] = useState(1);
  const [selectedAttendee, setSelectedAttendee] = useState();

  return (
    <Box>
      {totalElements > 0 && (
        <Pagination
          pageFrom={pageFrom}
          pageCount={pageCount}
          listSize={listSize}
          currentPage={currentPage}
          totalElements={totalElements}
          handlePageClick={value => {
            setPageFrom(value.selected * listSize);
            setCurrentPage(value.selected + 1);
          }}
        />
      )}
      <Heading>
        <Title size={3}>Booking By Attendee</Title>
      </Heading>

      <CustomTable>
        <Table.Head>
          <Table.Row>
            <Table.Heading>
              <div>
                <span>
                  <a
                    onClick={() => {
                      const ticket =
                        attendeeNameSort === 'ATTENDEE_NAME_ASC'
                          ? sortBy(ticketData, 'ATTENDEE_NAME')
                          : reverse(ticketData);
                      setTicketData(ticket);
                      setAttendeeNameSort(
                        attendeeNameSort === 'ATTENDEE_NAME_ASC'
                          ? 'ATTENDEE_NAME_DESC'
                          : 'ATTENDEE_NAME_ASC',
                      );
                    }}
                  >
                    <i
                      className={
                        attendeeNameSort === 'ATTENDEE_NAME_ASC'
                          ? 'fas fa-sort-amount-down'
                          : 'fas fa-sort-amount-up'
                      }
                    />
                  </a>{' '}
                  Attendee
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <a
                    onClick={() => {
                      const ticket =
                        emailSort === 'ATTENDEE_EMAIL_ASC'
                          ? sortBy(ticketData, 'ATTENDEE_EMAIL')
                          : reverse(ticketData);
                      setTicketData(ticket);
                      setEmailSort(
                        emailSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'ATTENDEE_EMAIL_DESC'
                          : 'ATTENDEE_EMAIL_ASC',
                      );
                    }}
                  >
                    <i
                      className={
                        emailSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'fas fa-sort-amount-down'
                          : 'fas fa-sort-amount-up'
                      }
                    />
                  </a>{' '}
                  Email
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <a
                    onClick={() => {
                      const ticket =
                        mobileSort === 'ATTENDEE_EMAIL_ASC'
                          ? sortBy(ticketData, 'ATTENDEE_EMAIL')
                          : reverse(ticketData);
                      setTicketData(ticket);
                      setMobileSort(
                        mobileSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'ATTENDEE_EMAIL_DESC'
                          : 'ATTENDEE_EMAIL_ASC',
                      );
                    }}
                  >
                    <i
                      className={
                        mobileSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'fas fa-sort-amount-down'
                          : 'fas fa-sort-amount-up'
                      }
                    />
                  </a>{' '}
                  Mobile
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <a
                    onClick={() => {
                      const ticket =
                        ageSort === 'ATTENDEE_EMAIL_ASC'
                          ? sortBy(ticketData, 'ATTENDEE_EMAIL')
                          : reverse(ticketData);
                      setTicketData(ticket);
                      setAgeSort(
                        ageSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'ATTENDEE_EMAIL_DESC'
                          : 'ATTENDEE_EMAIL_ASC',
                      );
                    }}
                  >
                    <i
                      className={
                        ageSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'fas fa-sort-amount-down'
                          : 'fas fa-sort-amount-up'
                      }
                    />
                  </a>{' '}
                  Age
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <a
                    onClick={() => {
                      const ticket =
                        ticketNameSort === 'ATTENDEE_EMAIL_ASC'
                          ? sortBy(ticketData, 'ATTENDEE_EMAIL')
                          : reverse(ticketData);
                      setTicketData(ticket);
                      setTicketNameSort(
                        ticketNameSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'ATTENDEE_EMAIL_DESC'
                          : 'ATTENDEE_EMAIL_ASC',
                      );
                    }}
                  >
                    <i
                      className={
                        ticketNameSort === 'ATTENDEE_EMAIL_ASC'
                          ? 'fas fa-sort-amount-down'
                          : 'fas fa-sort-amount-up'
                      }
                    />
                  </a>{' '}
                  Ticket Category
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <a
                    onClick={() => {
                      const ticket =
                        ticketNumberSort === 'TICKET_NUMBER_ASC'
                          ? sortBy(ticketData, 'TICKET_NUMBER')
                          : reverse(ticketData);
                      setTicketData(ticket);
                      setTicketNumberSort(
                        ticketNumberSort === 'TICKET_NUMBER_ASC'
                          ? 'TICKET_NUMBER_DESC'
                          : 'TICKET_NUMBER_ASC',
                      );
                    }}
                  >
                    <i
                      className={
                        ticketNumberSort === 'TICKET_NUMBER_ASC'
                          ? 'fas fa-sort-amount-down'
                          : 'fas fa-sort-amount-up'
                      }
                    />
                  </a>{' '}
                  Ticket No
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>Status</span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>Action</span>
              </div>
            </Table.Heading>
          </Table.Row>
        </Table.Head>
        <View
          ticket={tickets}
          step={step}
          setStep={setStep}
          ticketData={ticketData}
          setTicketData={setTicketData}
          setPageCount={setPageCount}
          setTotalElements={setTotalElements}
          setSelectedAttendee={setSelectedAttendee}
          booking={booking}
        />
      </CustomTable>

      <Wrapper>
        <Footer />
      </Wrapper>
    </Box>
  );
};
export default BookingByAttendee;

const View = ({
  ticket,
  booking,
  setPageCount,
  setTotalElements,
  setTicketData,
  ticketData,
  setStep,
  step,
  setSelectedAttendee,
}) => {
  console.log('ticket', ticket);

  useEffect(() => {
    setPageCount(ticket.total_pages);
    setTotalElements(ticket.total_size);
    if (ticket.ticket_record_listing) {
      setTicketData(ticket.ticket_record_listing);
    }
  }, [ticket.total_pages]);

  return (
    <tbody>
      {ticketData.map(tickets => (
        <tr key={tickets.ticket_number}>
          <BookingByAttendeeList
            goToStepTwo={() => {
              setStep(2);
              setSelectedAttendee(ticket);
            }}
            tickets={tickets}
            booking={booking}
          />
        </tr>
      ))}
    </tbody>
  );
};
